export default {
  message: {
    title: 'Official Customer Service',
    dispute: {
      id: 'Dispute ID',
      createdAt: 'Initiation Time',
      orderDetails: 'Order Details',
      inArbitration: 'In Arbitration',
      serialNumber: 'Serial Number',
      orderNumber: 'Order Number',
      txnAmount: 'Total Amount',
      enableRefundAmount: 'Refundable Amount',
      holderEmail: 'Consumer Email',
      holderName: 'Consumer Name',
      txnTime: 'Order Date',
      txnWebsite: 'Transaction Website',
      productInfo: 'Products',
      endDispute: 'Close Dispute',
      applyArbitration: 'Apply For Arbitration',
      reset: 'Reset',
      send: 'Send',
      apply: 'Initiate Disputes',
      cardNoLast4: 'Last 4 Digits Of Card Number',
      type: 'Dispute Type',
      claims: 'Claims',
      claimsPlaceholder: 'Please enter the main reason for your dispute and the expected solution',
      nameHello: 'Dear {name}',
      orderInfo: 'You made a <span class="amount"> {currency} {amount} </span> purchase on <a href="{link}" target="_blank" class="website"> {website} </a> from <span class="date"> {date} </span>',
      tip: 'If you have any questions about this order, please enter and send dispute information',
      systemMessage: 'System messages',
      typeOptions: {
        unknow: 'Unknow',
        fraud: 'Fraud',
        unauthorized: 'Unauthorized',
        wrongGoods: 'Products Discrepancies',
        productNotReceived: 'Product Not Received',
        defectiveMerchandise: 'Defective Merchandise',
        incorrectTransaction: 'Incorrect Transaction',
        wrongAddress: 'Wrong address',
        creditNotProcessed: 'Credit Not Processed'
      },
      status: {
        0: 'In Coordination',
        1: 'In Arbitration',
        // 2: '已仲裁',去掉这个状态，不翻译
        3: 'Ended'
      },
      applyArbitrationSuccess: 'You have applied for arbitration',
      endDisputeSuccess: 'You have ended this dispute',
      comfirm: 'Submit',
      logisticsNumber: 'Tracking No'
    },
    checkout: {
      title: 'Страница безопасной оплаты',
      description: 'Мы надежно шифруем вашу финансовую информацию',
      methodErrorTips: 'Извините, выбранная вами страна в настоящее время не поддерживается. Пожалуйста, выберите другую страну и попробуйте снова.',
      recommendation: 'Рекомендация',
      cardNumber: 'Номер карты',
      cardName: 'Имя на карте',
      cvv: 'CVV',
      expiredDate: 'Срок действия',
      billingInfo: 'Платежная информация',
      country: 'Страна',
      state: 'Штат',
      firstName: 'Имя',
      lastName: 'Фамилия',
      document: 'Документ',
      city: 'Город',
      address: 'Адрес',
      streetNumber: 'Номер улицы',
      zipCode: 'Почтовый индекс',
      email: 'Эл. почта',
      phone: 'Номер телефона',
      pay: 'ОПЛАТИТЬ',
      choosePaymentMethod: 'Выберите способ оплаты',
      continue: 'Продолжить',
      later: 'Позже',
      returnToMerchant: 'Отмена и возврат к продавцу',
      resultToMerchant: 'Возврат к продавцу',
      orderId: 'Номер заказа',
      orderAmount: 'Сумма заказа',
      billingDescriptor: 'Платежное описание',
      goodsName: 'Название товара',
      timeLimit: 'Пожалуйста, завершите оплату в течение указанного времени, иначе страница истечет',
      otherPaymentMethods: 'Другие способы оплаты',
      close: 'Закрыть',
      paymentErrorTitle: 'Оплата не удалась',
      paymentErrorTip: 'Ваш платеж не был успешно обработан. Пожалуйста, попробуйте еще раз.',
      paymentFailed: 'Процесс оплаты не удался',
      continueShopping: 'Продолжить покупки',
      paymentSuccess: 'Процесс оплаты успешно завершен',
      paymentPending: 'Платеж отправлен, подтверждение',
      correctDateTip: 'Пожалуйста, введите действительную дату истечения срока',
      correctCardNumberTip: 'Пожалуйста, введите действительный номер карты',
      correctSecurityCodeTip: 'Пожалуйста, введите действительный код безопасности',
      mobileMoneyOperator: 'Оператор мобильных денег',
      bank: 'Банк',
      correctEmailAddressTip: 'Пожалуйста, введите действительный адрес электронной почты',
      notSupportPaymentTip: 'Текущая среда не поддерживает оплату {type}',
      addValidPaymentCard: 'Пожалуйста, добавьте действительную платежную карту',
      timeLimitTip: 'Платеж будет списан за 12 часов до окончания пробного периода (<span class="date">{date}</span>), после чего продление будет происходить каждые <span class="date">{month}</span> месяцев на сумму <span class="amount"> {amount} {currency}</span>, отмена возможна в любое время',
      product: 'Продукт/услуга',
      subscribeType: 'Тип подписки',
      renewCycle: 'Период продления',
      renewAmount: 'Сумма продления',
      subscribePay: 'Подписаться и оплатить',
      readAgreement: "Прочитать и согласиться с <span class='protocol-link' style='color: #31a7da;'>《Соглашением об автоматическом продлении》</span>",
      depict: 'Описание',
      copyQrCode: 'Копировать QR-код',
      copySuccess: 'Копирование успешно',
      copyError: 'Копирование не удалось',
      refreshQrCode: 'Обновить QR-код'
    },
    subscribe: {
      yourSubscribe: 'Ваша подписка',
      unsubscribeTip: 'Для отмены нажмите кнопку [Отменить подписку] внизу страницы.',
      renewTip: 'Списание <span class="amount"> {amount} {currency}</span> <span class="date">{date}</span>, отмена возможна в любое время',
      unsubscribe: 'Отменить подписку',
      autoRenew: 'Соглашение об автоматическом продлении',
      unsubscribeTipTwo: 'Если отменить сейчас, вы сможете использовать подписку до <span class="date">{date}</span>.',
      emailVerifyTip: 'Подтверждение электронной почты',
      inputCodeTip: 'Пожалуйста, введите код подтверждения',
      sendSuccessTip: 'Код подтверждения успешно отправлен',
      sendErrorTip: 'Не удалось отправить код подтверждения',
      unsubscribeSuccessTip: 'Подписка успешно отменена',
      unsubscribeErrorTip: 'Не удалось отменить подписку',
      sendCodeTip: 'Повторная отправка через {code} секунд',
      sendEmailTip: 'Получить код подтверждения',
      daily: 'Каждый день',
      weekly: 'Каждые 7 дней',
      monthly: 'Каждые 30 дней',
      quarterly: 'Каждые 90 дней',
      semiAnnually: 'Каждые 180 дней',
      annually: 'Каждые 365 дней',
      regularRenewal: 'Регулярное продление',
      oneTime: 'Разовый',
      inputNumberTip: 'Пожалуйста, введите только цифры',
      eachCalendarMonth: 'Каждый календарный месяц'
    },
    common: {
      confirm: 'Подтвердить',
      cancel: 'Отмена',
      uploadImgErrorTip: 'Разрешено загружать только изображения',
      inputMessageTip: 'Пожалуйста, заполните содержимое',
      sendSuccessTip: 'Отправка успешна',
      sendErrorTip: 'Отправка не удалась',
      inputPlaceholder: 'Пожалуйста, введите {field}',
      selectPlaceholder: 'Пожалуйста, выберите {field}',
      correctFormat: 'Пожалуйста, введите правильный формат, например: {example}'
    }
  }
}
